/// <amd-module name="Artifacts/Root/helpers/ProjectHelpers" />
import { ProjectVisibility } from "Tfs/Platform/Contracts/Core";
import { IProjectData, ITfsPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export function getCurrentSelectedProjectId(pageContext: IVssPageContext): string | null {
  const tfsProject = getTfsProject(pageContext);
  return tfsProject ? tfsProject.id : null;
}

export function getCurrentSelectedProjectName(pageContext: IVssPageContext): string | null {
  const tfsProject = getTfsProject(pageContext);
  return tfsProject ? tfsProject.name : null;
}

export function isCurrentSelectedProjectPublic(pageContext: IVssPageContext): boolean {
  const tfsProject = getTfsProject(pageContext);
  const projectVisibility = tfsProject ? tfsProject.visibility : null;
  return projectVisibility === ProjectVisibility.Public;
}

export function getTfsProject(pageContext: IVssPageContext): IProjectData | undefined {
  const contributionService = pageContext.getService<IVssContributionService>(
    "IVssContributionService",
  );

  const tfsPageData = contributionService.getData<ITfsPageData>("ms.vss-tfs-web.page-data");

  return tfsPageData ? tfsPageData.project : undefined;
}
